import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./AdminsUIHelpers";

const AdminsUIContext = createContext();

export function useAdminsUIContext() {
  return useContext(AdminsUIContext);
}

export const AdminsUIConsumer = AdminsUIContext.Consumer;

export function AdminsUIProvider({ adminsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    newAdminButtonClick: adminsUIEvents.newAdminButtonClick,
    openEditAdminPage: adminsUIEvents.openEditAdminPage,
    openDeleteAdminDialog: adminsUIEvents.openDeleteAdminDialog,
    openDeleteAdminsDialog: adminsUIEvents.openDeleteAdminsDialog,
    openFetchAdminsDialog: adminsUIEvents.openFetchAdminsDialog,
    openUpdateAdminsStatusDialog:
    adminsUIEvents.openUpdateAdminsStatusDialog,
  };

  return (
    <AdminsUIContext.Provider value={value}>
      {children}
    </AdminsUIContext.Provider>
  );
}
